module.exports = __webpack_public_path__ + "img/stoerer3.f3842a60.png";